"use client";

import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

// === Estilo mejorado del Chip ===
const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "shape" && prop !== "position",
})(({ shape, position }) => ({
  position: "absolute",
  zIndex: 2,
  top: "12px",
  left: position === "right" ? "auto" : "12px",
  right: position === "right" ? "12px" : "auto",
  paddingLeft: 6,
  paddingRight: 6,
  height: 22,
  fontWeight: 600,
  fontSize: "0.7rem",
  textTransform: "uppercase",
  borderRadius: shape === "square" ? 4 : 12,
  background: "linear-gradient(135deg, #f44336, #ff9800)",
  color: "white",
  boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
  "& .MuiChip-label": {
    padding: 0,
  },
}));

export default function DiscountChip({
  discount = 0,
  shape = "rounded",
  position = "left", // "left" | "right"
  ...props
}) {
  if (discount <= 0) return null;

  const formattedDiscount =
    discount % 1 === 0 ? `-${discount}%` : `-${discount.toFixed(1)}%`;

  return (
    <StyledChip
      size="small"
      shape={shape}
      position={position}
      label={formattedDiscount}
      {...props}
    />
  );
}
